export function Meter({ value, label, tone = "teal" }) {
  const bounded = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div className="meter" aria-label={`${label}: ${bounded}%`}>
      <div className="meter-row">
        <span>{label}</span>
        <strong>{bounded}%</strong>
      </div>
      <div className="meter-track">
        <div className={`meter-fill ${tone}`} style={{ width: `${bounded}%` }} />
      </div>
    </div>
  );
}
